import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { withPrefetchedData } from 'src/shared/prefetch';

import { prefetchPageContext, StartAPetitionPageContextProvider } from 'src/app/pages/startAPetition/pageContext';

import { Head } from '../components/Head';
import { StartAPetitionLayout } from '../layout';

import { MutationObserverContainer } from './MutationObserverContainer';

/**
 * TODO: move the `<Head>` component to the layout once the page state
 * context can be server rendered.
 *
 * See `src/app/pages/startAPetition/pageContext/provider.tsx` for details
 */
export const StartAPetition = withPrefetchedData(
	(): JSX.Element => {
		return (
			<MutationObserverContainer>
				<StartAPetitionPageContextProvider
					loadingFallback={
						<>
							<Head />
							<Flex
								sx={{
									alignItems: 'center',
									justifyContent: 'center',
									height: ['calc(100vh - 48px)', 'calc(100vh - 58px)'],
									width: '100%',
								}}
							>
								<Loader size="m" data-testid="loading-spinner" />
							</Flex>
						</>
					}
				>
					<Head />
					<StartAPetitionLayout />
				</StartAPetitionPageContextProvider>
			</MutationObserverContainer>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
